(function (jQuery) {
	"use strict";

	function FloatingLabels() {
		var fn = {
			init: function() {
				jQuery('.js-floating-root').on('click', fn.rootClick);
				jQuery('.js-floating-label-input').each((i, elem) => fn.onChange.bind(elem)());
				jQuery('body')
					.on('focusin focusout keydown keyup change', '.js-floating-label-input', fn.onChange)
					.on('input', '.js-floating-label-input', fn.removeAutofillClass)
					.addClass('has-fields-loaded');

				jQuery(document).ready(function() {
					fn.checkAutofill();
				});
			},

			rootClick: function() {
				jQuery(this).find('input, select, textarea').focus();
			},

			onChange: function() {
				const elem = jQuery(this);
				const root = elem.parents('.js-floating-root');

				let hasContent = false;
				if (this.nodeName !== 'SELECT' && elem.val() !== '') {
					hasContent = true;
				} else if (this.nodeName === 'SELECT' && elem.find('option:selected').text().trim() !== '') {
					hasContent = true;
				}

				if (hasContent) {
					root.addClass('has-content');
				} else {
					root.removeClass('has-content');
				}

				if (document.activeElement === this) {
					root.addClass('has-focus');
				} else {
					root.removeClass('has-focus');
				}
			},

			checkAutofill: function() {
				jQuery('.js-floating-root input:-webkit-autofill').each(function() {
					jQuery(this).closest('.js-floating-root').addClass('has-autofill');
				});
			},

			removeAutofillClass: function() {
				jQuery('.js-floating-root').removeClass('has-autofill');
				fn.checkAutofill();
			}
		}

		jQuery(fn.init);
	}

	new FloatingLabels();
})(jQuery);